(function() {
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const item = entry.target;
      const hasAnimation = item.dataset.onScrollAnimation;

      if(!hasAnimation) return;

      const animation = `sp-animate-${item.dataset.onScrollAnimation}-animation`;
      if (entry.isIntersecting) {
        item.classList.add(animation);
        return;
      }
      
      // Not Intersecting
      console.log('Not Intersecting')
      item.classList.remove(animation);
    });
  });
  
  const animations = document.querySelectorAll('[data-on-scroll-animation]');
  
  animations.forEach(animation => {
    animation.classList.add('sp-opacity-0');
    observer.observe(animation);
  });
})();